export const VideoSection = ({ data }: any) => {
    return (
        <div className="py-12 px-4 container mx-auto">
            {data.title && <h2 className="text-3xl font-bold text-center mb-8">{data.title}</h2>}
            <div className="max-w-4xl mx-auto aspect-video bg-black rounded-xl overflow-hidden shadow-xl">
                {data.videoUrl ? (
                    <iframe
                        src={data.videoUrl.replace("watch?v=", "embed/")}
                        className="w-full h-full"
                        allowFullScreen
                        title="Video"
                    />
                ) : (
                    <div className="flex items-center justify-center h-full text-white">
                        No Video URL
                    </div>
                )}
            </div>
        </div>
    );
};
